import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./item.module.scss";

function SidebarItem({
  title,
  path,
  preview,
  minPrice,
  selected,
  shortTitle,
  onClick
}) {
  const titleWithoutProductName = shortTitle;

  return preview ? (
    <a
      href={path ? path : `#`}
      onClick={onClick}
      className={classNames(styles.root, selected ? styles.rootSelected : ``)}
    >
      <div className={styles.preview}>
        <img loading="lazy" src={preview} alt={title} />
      </div>
      <div className={styles.title}>
        {title.length > 25 ? `${title.slice(0, 25)}...` : title}
      </div>
      <div className={styles.price}>от {minPrice} ₽</div>
    </a>
  ) : (
    <a
      href={path ? path : `#`}
      onClick={onClick}
      className={classNames(
        styles.button,
        selected ? styles.buttonSelected : ``
      )}
    >
      {titleWithoutProductName}
    </a>
  );
}

SidebarItem.propTypes = {
  title: PropTypes.string,
  shortTitle: PropTypes.string,
  path: PropTypes.string,
  preview: PropTypes.string,
  minPrice: PropTypes.number,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};

export default SidebarItem;
